import { MoonIcon, SunIcon } from "@radix-ui/react-icons";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/components/theme-provider";

export function ModeToggle() {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <Button variant="outline" size="sm" onClick={toggleTheme} className="gap-2">
      {theme === "light" ? (
        <>
          <SunIcon className="h-4 w-4" />
        </>
      ) : (
        <>
          <MoonIcon className="h-4 w-4" />
        </>
      )}
    </Button>
  );
}
